export default "__VITE_ASSET__979d97b2__"